import { app } from '../../../../../app';
import { Controller } from './hard-token-synchronize.controller';

app.component('editHardTokenSynchronize', {
   bindings: {
        companyId: '<',
        token: '<',
    },
    controller: Controller,
    templateUrl: require('./hard-token-synchronize.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/synchronize/hard-token-synchronize.component.js